module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg11-2aca799f557c3da3ab751b98a97115e6.png";